const yup = require("yup");

// Schema for createcollegerules
const create = yup.object({
  trx: yup.string().required("Transaction code is required"),
  amount: yup.number().required("Amount is required"),
});

module.exports = {
  create,
};
